import { PureComponent } from 'react';
import Popup from 'Component/Popup';
import Form from 'Component/Form';
import Field from 'Component/Field';
import Html from 'Component/Html';
import './ProductPriceAlert.style';

export const PRICE_ALERT_POPUP_ID = 'PRICE_ALERT_POPUP_ID';

class ProductPriceAlert extends PureComponent {
    renderPopup() {
        const { onPriceAlertSubmitSuccess } = this.props;

        return (
            <Popup
              id={ PRICE_ALERT_POPUP_ID }
              mix={ { block: 'ProductPriceAlert', elem: 'Popup' } }
            >
                <Form onSubmitSuccess={ onPriceAlertSubmitSuccess } >
                    <Field
                        type="email"
                        id="email"
                        name="email"
                        label={ __("Email") }
                        validation={ ['notEmpty', 'email'] }
                    />
                    <div block="Field" elem="Text">
                        <Html content={ __('I agree with the <a href="/page/privacy-policy" target="_blank">Privacy Policy</a>') } />
                    </div>
                    <button block="Button" mods={{ isPrimary: true, isBig: true }}>{ __('Send') }</button>
                </Form>
            </Popup>
        );
    }

    renderTrigger() {
        const { onTriggerClick } = this.props;

        return <span block="ProductPriceAlert" elem="Trigger" onClick={ onTriggerClick }>{ __("Let me know when it's on sale") }</span>
    }

    render() {
        const { product_type } = this.props;

        return (
            <div block="ProductPriceAlert" mods={{ disabled: product_type === 'configurable' }}>
                { this.renderTrigger() }
                { this.renderPopup() }
            </div>
        );
    }
}

export default ProductPriceAlert;
